// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftSideBar {
  box-shadow: 4px 0px 10px rgba(221, 221, 221, 0.25);
  width: 316px;
  height: 100%;
  z-index: 15;
  transition: 350ms ease-in;
}
.leftSideBar .left_sidebar_scroll {
  overflow-x: hidden;
  padding: 0px 8px 30px;
  height: 100%;
  overflow-y: auto !important;
  max-height: 784px;
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.leftSideBar .left_sidebar_scroll::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}
.leftSideBar .left_sidebar_scroll::-webkit-scrollbar-track {
  background: rgba(180, 178, 178, 0.4509803922);
  border-radius: 10px;
}
.leftSideBar .left_sidebar_scroll::-webkit-scrollbar-thumb {
  background: #808080;
  border-radius: 10px;
}
.leftSideBar .left_sidebar_scroll::-webkit-scrollbar-thumb:hover {
  background: #808080;
  border-radius: 10px;
}
.leftSideBar .logoWrapper {
  padding: 0 0 8px 20px;
  width: 100%;
  max-width: 229px;
  min-height: 40px;
}

.hide_images {
  display: block;
}

.visible_images {
  display: none;
}

.image_show_button {
  display: none !important;
}

.image_show_button2 {
  display: block !important;
}

@media screen and (max-width: 767.99px) {
  .visible_images {
    display: block !important;
  }
  .hide_images {
    display: none !important;
  }
}
.new_close_button {
  position: absolute;
  right: 10px;
  bottom: 5px;
  font-size: 28px;
  border: 0px;
  background-color: #4c00ef;
  padding: 0px 5px;
  width: 30px;
  transition: 0.3s;
}
.new_close_button svg {
  color: #fff;
}
.new_close_button.rotate {
  transform: rotate(180deg);
}

.active.toggle_sidebar {
  width: 60px;
}
.active.toggle_sidebar .menuItemWrapper li > a span:last-of-type {
  display: none;
}

.visible_button {
  display: none !important;
}

.new_close_button:hover {
  background-color: #ff7020;
  transition: 0.3s;
}

.menuItemWrapper {
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 400;
  color: #9A9A9A;
  margin-top: 25px;
}
.menuItemWrapper li {
  margin-bottom: 5px;
}
.menuItemWrapper li > a {
  border-radius: 4px;
  font-family: var(--font-family);
  padding: 12px 0;
  color: inherit;
  text-decoration: none;
  transition: 150ms all ease-in;
}
.menuItemWrapper li > a svg > path {
  fill: #65B5FF;
}
.menuItemWrapper li > a .new_icon {
  background-color: #65B5FF;
}
.menuItemWrapper li > a.active, .menuItemWrapper li > a:hover {
  box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.25);
  transition: 350ms shadow ease-out;
  color: #000;
}
.menuItemWrapper li > a.active .new_icon, .menuItemWrapper li > a:hover .new_icon {
  background-color: #2665F2;
}
.menuItemWrapper .icon {
  text-align: center;
  min-width: 36px;
  padding-right: 18px;
  padding-left: 15px;
}

.sideToggler {
  position: absolute;
  right: -10px;
  bottom: 15px;
}
.sideToggler svg {
  margin-left: -5px;
  transition: 250ms;
}
.sideToggler.rotate {
  transform: rotate(180deg);
  margin-right: 20px;
}

@media screen and (max-width: 1200px) {
  .leftSideBar {
    width: 250px;
  }
  .menuItemWrapper li > a {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .leftSideBar .logoWrapper {
    padding-left: 3px;
  }
  .leftSideBar .logoWrapper > img {
    width: 42px;
    height: 30px;
    object-fit: cover;
    object-position: left;
  }
  .leftSideBar.active {
    width: 60px;
  }
  .leftSideBar.active .menuItemWrapper li > a span:last-of-type {
    display: none;
  }
  .leftSideBar.active .menuItemWrapper li > button span:last-of-type {
    display: none;
  }
  .menuItemWrapper li > a span:last-of-type {
    white-space: nowrap;
  }
  .menuItemWrapper .icon {
    padding-right: 0;
    padding-left: 7px;
  }
}
@media screen and (max-width: 768px) {
  .middle-col {
    margin-top: 2%;
  }
}
.success-btn {
  width: 100%;
  padding: 10px 20px;
  border-radius: 50px;
}

.danger-btn {
  width: 100%;
  color: white;
  background-color: #ff0800;
  padding: 10px 20px;
  border-radius: 50px;
}

.danger-btn:hover {
  color: white;
}

.primary-btn {
  width: 100%;
  color: white;
  background-color: #4c00ef;
  padding: 10px 20px;
  border-radius: 50px;
}

.primary-btn:hover {
  color: white;
}

.modal-img {
  height: 80px;
  width: 100%;
  margin: auto;
}

.modal-text {
  text-align: center;
  margin: auto;
}

.modal-row {
  margin: auto;
}

.alert-img {
  height: 80px;
  width: 20%;
  margin-left: 39%;
}

.header_class {
  overflow: hidden;
}

.content_class {
  margin-top: -140%;
  transition: 0.5s;
  list-style: none;
}
.content_class li {
  white-space: nowrap;
}

.content_class.active_buisness {
  transition: 0.5s;
  margin-top: 0px;
}

.j_sidebar_main_text {
  display: block;
}

.j_sidebar_main_text + span {
  display: block;
}

.menuItemWrapper.active .j_sidebar_main_text {
  display: none !important;
  white-space: nowrap;
}
.menuItemWrapper.active .j_sidebar_main_text + span {
  display: none !important;
  white-space: nowrap;
}
.menuItemWrapper.active .responsive_one {
  margin-top: -234px;
}
.menuItemWrapper.active .responsive_two {
  margin-top: -234px;
}
.menuItemWrapper.active .responsive_three {
  margin-top: -234px;
}
.menuItemWrapper.active .header_class .content_class.responsive_one.active_buisness {
  margin-top: 0px !important;
  padding: 0px;
}
.menuItemWrapper.active .header_class .content_class.responsive_two.active_buisness {
  margin-top: 0px !important;
  padding: 0px;
}
.menuItemWrapper.active .header_class .content_class.responsive_three.active_buisness {
  margin-top: 0px !important;
  padding: 0px;
}

.down_icon {
  margin-left: 115px;
}

.down_icon_two {
  margin-left: 59px;
}

.down_icon_three {
  margin-left: 71px;
}

.sub_icon {
  margin-left: 4px;
}

@media screen and (max-width: 1200px) {
  .toggle_sidebar .menuItemWrapper.active .icon {
    display: block;
  }
}
@media screen and (max-width: 1199px) {
  .down_icon {
    margin-left: 61px !important;
  }
  .down_icon_two {
    margin-left: 9px !important;
  }
  .down_icon_three {
    margin-left: 20px !important;
  }
  .sub_icon {
    margin-left: -22px !important;
  }
  .leftSideBar.toggle_sidebar .menuItemWrapper li > a .icon {
    padding-right: 18px;
    padding-left: 13px !important;
  }
}
@media screen and (max-width: 768px) {
  .content_class {
    padding-left: 10px;
  }
  .responsive_one {
    margin-top: -396%;
  }
  .responsive_two {
    margin-top: -179%;
  }
  .responsive_three {
    margin-top: -380px;
  }
  .j_sidebar_main_text {
    display: none;
  }
  .j_sidebar_main_text + span {
    display: none;
  }
  .leftSideBar.toggle_sidebar {
    width: 60px;
  }
  .leftSideBar.toggle_sidebar {
    width: 250px;
  }
  .leftSideBar.toggle_sidebar .menuItemWrapper li > a span.j_sidebar_main_text,
  .leftSideBar.toggle_sidebar .menuItemWrapper li > a span:last-of-type {
    display: block !important;
    color: #000;
  }
  .image_show_button {
    display: block !important;
  }
  .leftSideBar.toggle_sidebar .menuItemWrapper li > a .icon {
    padding-right: 18px;
    padding-left: 13px !important;
  }
  .menuItemWrapper li > a {
    padding: 8px 0;
  }
  .menuItemWrapper.active .header_class .content_class.responsive_three.active_buisness {
    margin-top: 0px !important;
    padding: 0px 0px 0px 10px;
  }
}
.menuItemWrapper li > a.active_new_customer svg > path,
.menuItemWrapper li > a.active_customers svg > path,
.menuItemWrapper li > a.active_account svg > path,
.menuItemWrapper li > a.active_customize svg > path {
  fill: #2665F2 !important;
}

.navbar-light .navbar-nav .nav-link:hover .new_icon {
  background-color: #2665F2;
}`, "",{"version":3,"sources":["webpack://./src/styles/leftsidebar.scss"],"names":[],"mappings":"AAAA;EACI,kDAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;AACJ;AACI;EACI,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,iBAAA;EAQA,UAAA;EAMA,WAAA;EAMA,oBAAA;AAhBR;AADQ;EACI,UAAA;EACA,mBAAA;AAGZ;AACQ;EACI,6CAAA;EACA,mBAAA;AACZ;AAGQ;EACI,mBAAA;EACA,mBAAA;AADZ;AAKQ;EACI,mBAAA;EACA,mBAAA;AAHZ;AAOI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AALR;;AAkBA;EACI,cAAA;AAfJ;;AAkBA;EACI,aAAA;AAfJ;;AAkBA;EACI,wBAAA;AAfJ;;AAkBA;EACI,yBAAA;AAfJ;;AAkBA;EACI;IACI,yBAAA;EAfN;EAkBE;IACI,wBAAA;EAhBN;AACF;AAoBA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAlBJ;AAoBI;EACI,WAAA;AAlBR;AAqBI;EACI,yBAAA;AAnBR;;AAyBA;EACI,WAAA;AAtBJ;AAwBI;EACI,aAAA;AAtBR;;AA2BA;EACI,wBAAA;AAxBJ;;AA2BA;EACI,yBAAA;EACA,gBAAA;AAxBJ;;AA2BA;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAxBJ;AA0BI;EACI,kBAAA;AAxBR;AA0BQ;EAEI,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;AAzBZ;AA4BgB;EACI,aAAA;AA1BpB;AA6BY;EACI,yBAAA;AA3BhB;AA6BY;EAEI,kDAAA;EACA,iCAAA;EACA,WAAA;AA5BhB;AAoCgB;EACI,yBAAA;AAlCpB;AA0CI;EACI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAxCR;;AA8CA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AA3CJ;AA6CI;EACI,iBAAA;EACA,iBAAA;AA3CR;AA+CI;EACI,yBAAA;EACA,kBAAA;AA7CR;;AAoDA;EACI;IACI,YAAA;EAjDN;EAoDE;IACI,eAAA;EAlDN;AACF;AA0DA;EACI;IACI,iBAAA;EAxDN;EA0DM;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,qBAAA;EAxDV;EA+DM;IACI,WAAA;EA7DV;EA+DU;IACI,aAAA;EA7Dd;EAiEU;IACI,aAAA;EA/Dd;EAsEM;IACI,mBAAA;EApEV;EAuEM;IACI,gBAAA;IACA,iBAAA;EArEV;AACF;AA2EA;EACI;IACI,cAAA;EAzEN;AACF;AA4EA;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;AA1EJ;;AA6EA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AA1EJ;;AA6EA;EACI,YAAA;AA1EJ;;AA6EA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AA1EJ;;AA6EA;EACI,YAAA;AA1EJ;;AA6EA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AA1EJ;;AA6EA;EACI,kBAAA;EACA,YAAA;AA1EJ;;AA6EA;EACI,YAAA;AA1EJ;;AA6EA;EACI,YAAA;EACA,UAAA;EACA,gBAAA;AA1EJ;;AA6EA;EACI,gBAAA;AA1EJ;;AA6EA;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AA1EJ;AA4EI;EACI,mBAAA;AA1ER;;AA+EA;EACI,gBAAA;EACA,eAAA;AA5EJ;;AA+EA;EACI,cAAA;AA5EJ;;AA+EA;EACI,cAAA;AA5EJ;;AAsFI;EACI,wBAAA;EACA,mBAAA;AAnFR;AAsFI;EACI,wBAAA;EACA,mBAAA;AApFR;AAuFI;EACI,kBAAA;AArFR;AAwFI;EACI,kBAAA;AAtFR;AAyFI;EACI,kBAAA;AAvFR;AA0FI;EACI,0BAAA;EACA,YAAA;AAxFR;AA2FI;EACI,0BAAA;EACA,YAAA;AAzFR;AA4FI;EACI,0BAAA;EACA,YAAA;AA1FR;;AAgGA;EACI,kBAAA;AA7FJ;;AAgGA;EACI,iBAAA;AA7FJ;;AAgGA;EACI,iBAAA;AA7FJ;;AAgGA;EACI,gBAAA;AA7FJ;;AAoGA;EACI;IACI,cAAA;EAjGN;AACF;AAoGA;EACI;IACI,4BAAA;EAlGN;EAqGE;IACI,2BAAA;EAnGN;EAsGE;IACI,4BAAA;EApGN;EAuGE;IACI,6BAAA;EArGN;EAwGE;IACI,mBAAA;IACA,6BAAA;EAtGN;AACF;AAyGA;EACI;IACI,kBAAA;EAvGN;EA0GE;IACI,iBAAA;EAxGN;EA2GE;IACI,iBAAA;EAzGN;EA4GE;IACI,kBAAA;EA1GN;EA6GE;IACI,aAAA;EA3GN;EA8GE;IACI,aAAA;EA5GN;EA+GE;IACI,WAAA;EA7GN;EAgHE;IACI,YAAA;EA9GN;EAiHE;;IAEI,yBAAA;IACA,WAAA;EA/GN;EAkHE;IACI,yBAAA;EAhHN;EAmHE;IACI,mBAAA;IACA,6BAAA;EAjHN;EAqHE;IAEI,cAAA;EApHN;EAuHE;IACI,0BAAA;IACA,yBAAA;EArHN;AACF;AAwHA;;;;EAII,wBAAA;AAtHJ;;AAyHA;EAAsD,yBAAA;AArHtD","sourcesContent":[".leftSideBar {\n    box-shadow: 4px 0px 10px rgba(221, 221, 221, 0.25);\n    width: 316px;\n    height: 100%;\n    z-index: 15;\n    transition: 350ms ease-in;\n\n    .left_sidebar_scroll {\n        overflow-x: hidden;\n        padding: 0px 8px 30px;\n        height: 100%;\n        overflow-y: auto !important;\n        max-height: 784px;\n\n\n        &::-webkit-scrollbar {\n            width: 5px;\n            border-radius: 10px;\n        }\n\n        /* Track */\n        &::-webkit-scrollbar-track {\n            background: #b4b2b273;\n            border-radius: 10px;\n        }\n\n        /* Handle */\n        &::-webkit-scrollbar-thumb {\n            background: #808080;\n            border-radius: 10px;\n        }\n\n        /* Handle on hover */\n        &::-webkit-scrollbar-thumb:hover {\n            background: #808080;\n            border-radius: 10px;\n        }\n    }\n\n    .logoWrapper {\n        padding: 0 0 8px 20px;\n        width: 100%;\n        max-width: 229px;\n        min-height: 40px;\n\n\n    }\n\n\n\n}\n\n\n\n\n\n.hide_images {\n    display: block;\n}\n\n.visible_images {\n    display: none;\n}\n\n.image_show_button {\n    display: none !important;\n}\n\n.image_show_button2 {\n    display: block !important;\n}\n\n@media screen and (max-width:767.99px) {\n    .visible_images {\n        display: block !important;\n    }\n\n    .hide_images {\n        display: none !important;\n    }\n}\n\n\n.new_close_button {\n    position: absolute;\n    right: 10px;\n    bottom: 5px;\n    font-size: 28px;\n    border: 0px;\n    background-color: #4c00ef;\n    padding: 0px 5px;\n    width: 30px;\n    transition: 0.3s;\n\n    svg {\n        color: #fff;\n    }\n\n    &.rotate {\n        transform: rotate(180deg);\n\n    }\n\n}\n\n.active.toggle_sidebar {\n    width: 60px;\n\n    .menuItemWrapper li>a span:last-of-type {\n        display: none;\n\n    }\n}\n\n.visible_button {\n    display: none !important;\n}\n\n.new_close_button:hover {\n    background-color: #ff7020;\n    transition: 0.3s;\n}\n\n.menuItemWrapper {\n    font-family: var(--font-family);\n    font-size: 16px;\n    font-weight: 400;\n    color: #9A9A9A;\n    margin-top: 25px;\n\n    li {\n        margin-bottom: 5px;\n\n        &>a {\n\n            border-radius: 4px;\n            font-family: var(--font-family);\n            padding: 12px 0;\n            color: inherit;\n            text-decoration: none;\n            transition: 150ms all ease-in;\n\n            svg {\n                &>path {\n                    fill: #65B5FF;\n                }\n            }\n            .new_icon{\n                background-color: #65B5FF;\n            }\n            &.active,\n            &:hover {\n                box-shadow: 0px 4px 12px rgba(221, 221, 221, 0.25);\n                transition: 350ms shadow ease-out;\n                color: #000;\n\n                // svg {\n                //     &>path {\n                //         fill: #2665F2;\n                //     }\n\n                // }\n                .new_icon{\n                    background-color: #2665F2;\n                }\n            }\n            \n\n        }\n    }\n\n    .icon {\n        text-align: center;\n        min-width: 36px;\n        padding-right: 18px;\n        padding-left: 15px;\n    }\n\n\n}\n\n.sideToggler {\n    position: absolute;\n    right: -10px;\n    bottom: 15px;\n\n    svg {\n        margin-left: -5px;\n        transition: 250ms;\n    }\n\n\n    &.rotate {\n        transform: rotate(180deg);\n        margin-right: 20px;\n    }\n}\n\n\n\n\n@media screen and (max-width:1200px) {\n    .leftSideBar {\n        width: 250px;\n    }\n\n    .menuItemWrapper li>a {\n        font-size: 14px;\n    }\n\n}\n\n\n\n\n\n@media screen and (max-width:768px) {\n    .leftSideBar .logoWrapper {\n        padding-left: 3px;\n\n        &>img {\n            width: 42px;\n            height: 30px;\n            object-fit: cover;\n            object-position: left;\n        }\n    }\n\n    .leftSideBar {\n\n\n        &.active {\n            width: 60px;\n\n            .menuItemWrapper li>a span:last-of-type {\n                display: none;\n\n            }\n\n            .menuItemWrapper li>button span:last-of-type {\n                display: none;\n\n            }\n        }\n    }\n\n    .menuItemWrapper {\n        li>a span:last-of-type {\n            white-space: nowrap;\n        }\n\n        .icon {\n            padding-right: 0;\n            padding-left: 7px;\n        }\n    }\n\n\n}\n\n@media screen and (max-width: 768px) {\n    .middle-col {\n        margin-top: 2%;\n    }\n}\n\n.success-btn {\n    width: 100%;\n    padding: 10px 20px;\n    border-radius: 50px;\n}\n\n.danger-btn {\n    width: 100%;\n    color: white;\n    background-color: #ff0800;\n    padding: 10px 20px;\n    border-radius: 50px;\n}\n\n.danger-btn:hover {\n    color: white;\n}\n\n.primary-btn {\n    width: 100%;\n    color: white;\n    background-color: #4c00ef;\n    padding: 10px 20px;\n    border-radius: 50px;\n}\n\n.primary-btn:hover {\n    color: white;\n}\n\n.modal-img {\n    height: 80px;\n    width: 100%;\n    margin: auto;\n}\n\n.modal-text {\n    text-align: center;\n    margin: auto;\n}\n\n.modal-row {\n    margin: auto;\n}\n\n.alert-img {\n    height: 80px;\n    width: 20%;\n    margin-left: 39%;\n}\n\n.header_class {\n    overflow: hidden;\n}\n\n.content_class {\n    margin-top: -140%;\n    transition: 0.5s;\n    list-style: none;\n\n    li {\n        white-space: nowrap;\n    }\n\n}\n\n.content_class.active_buisness {\n    transition: 0.5s;\n    margin-top: 0px;\n}\n\n.j_sidebar_main_text {\n    display: block;\n}\n\n.j_sidebar_main_text+span {\n    display: block;\n}\n\n\n\n\n\n\n.menuItemWrapper.active {\n\n    .j_sidebar_main_text {\n        display: none !important;\n        white-space: nowrap;\n    }\n\n    .j_sidebar_main_text+span {\n        display: none !important;\n        white-space: nowrap;\n    }\n\n    .responsive_one {\n        margin-top: -234px;\n    }\n\n    .responsive_two {\n        margin-top: -234px;\n    }\n\n    .responsive_three {\n        margin-top: -234px;\n    }\n\n    .header_class .content_class.responsive_one.active_buisness {\n        margin-top: 0px !important;\n        padding: 0px;\n    }\n\n    .header_class .content_class.responsive_two.active_buisness {\n        margin-top: 0px !important;\n        padding: 0px;\n    }\n\n    .header_class .content_class.responsive_three.active_buisness {\n        margin-top: 0px !important;\n        padding: 0px;\n    }\n}\n\n\n\n.down_icon {\n    margin-left: 115px;\n}\n\n.down_icon_two {\n    margin-left: 59px;\n}\n\n.down_icon_three {\n    margin-left: 71px;\n}\n\n.sub_icon {\n    margin-left: 4px;\n}\n\n\n\n\n\n@media screen and (max-width:1200px) {\n    .toggle_sidebar .menuItemWrapper.active .icon {\n        display: block;\n    }\n}\n\n@media screen and (max-width:1199px) {\n    .down_icon {\n        margin-left: 61px !important;\n    }\n\n    .down_icon_two {\n        margin-left: 9px !important;\n    }\n\n    .down_icon_three {\n        margin-left: 20px !important;\n    }\n\n    .sub_icon {\n        margin-left: -22px !important;\n    }\n\n    .leftSideBar.toggle_sidebar .menuItemWrapper li>a .icon {\n        padding-right: 18px;\n        padding-left: 13px !important;\n    }\n}\n\n@media screen and (max-width:768px) {\n    .content_class {\n        padding-left: 10px;\n    }\n\n    .responsive_one {\n        margin-top: -396%;\n    }\n\n    .responsive_two {\n        margin-top: -179%;\n    }\n\n    .responsive_three {\n        margin-top: -380px;\n    }\n\n    .j_sidebar_main_text {\n        display: none;\n    }\n\n    .j_sidebar_main_text+span {\n        display: none;\n    }\n\n    .leftSideBar.toggle_sidebar {\n        width: 60px;\n    }\n\n    .leftSideBar.toggle_sidebar {\n        width: 250px;\n    }\n\n    .leftSideBar.toggle_sidebar .menuItemWrapper li>a span.j_sidebar_main_text,\n    .leftSideBar.toggle_sidebar .menuItemWrapper li>a span:last-of-type {\n        display: block !important;\n        color: #000;\n    }\n\n    .image_show_button {\n        display: block !important;\n    }\n\n    .leftSideBar.toggle_sidebar .menuItemWrapper li>a .icon {\n        padding-right: 18px;\n        padding-left: 13px !important;\n    }\n\n\n    .menuItemWrapper li>a {\n\n        padding: 8px 0;\n    }\n\n    .menuItemWrapper.active .header_class .content_class.responsive_three.active_buisness {\n        margin-top: 0px !important;\n        padding: 0px 0px 0px 10px;\n    }\n}\n\n.menuItemWrapper li>a.active_new_customer svg>path,\n.menuItemWrapper li>a.active_customers svg>path,\n.menuItemWrapper li>a.active_account svg>path,\n.menuItemWrapper li>a.active_customize svg>path {\n    fill: #2665F2 !important;\n}\n\n.navbar-light .navbar-nav .nav-link:hover .new_icon { background-color: #2665F2; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
